function fn_part_products() {
    var products = $(".part-products");
    var filter_details = ".part-products .filter .details";
    if ($(filter_details).length) {
        nl_fn_switch_content(filter_details,0);
        $(".options-btn").on("click",function(e) {
            e.preventDefault();
            $(this).toggleClass("active").parents(".row").next(".details").stop(true).slideToggle(500).toggleClass("toggle");
        });
    }

    if ($("#range-slider").length) {
        var ui_slider = document.getElementById('range-slider');
        var range_min = document.getElementById('range-min');
        var range_max = document.getElementById('range-max');

        var range_min_val = $("#range-min").val();
        var range_max_val = $("#range-max").val();

        var data_min = $("#range-slider").data("min");
        var data_max = $("#range-slider").data("max");
        var data_step = $("#range-slider").data("step");

        noUiSlider.create(ui_slider, {
            start: [range_min_val, range_max_val],
            step: data_step,
            connect: true,
            range: {
                'min': data_min,
                'max': data_max
            }
        });

        ui_slider.noUiSlider.on('update', function( values, handle ) {
            var value = values[handle];
            if (!handle) {
                range_min.value = Math.round(value);
            } else {
                range_max.value = Math.round(value);
            }
        });

        ui_slider.noUiSlider.on('change', function( values, handle ) {
            $('#range-min').trigger('change');
        });

        range_max.addEventListener('change', function(){
            ui_slider.noUiSlider.set([null, this.value]);
        });

        range_min.addEventListener('change', function(){
            ui_slider.noUiSlider.set([this.value, null]);
        });

        var data_min_text = $("#range-slider").data("min-text");
        var data_max_text = $("#range-slider").data("max-text");
        $(".noUi-origin:first-of-type .noUi-handle").append("<i></i>").children().text(data_min_text);
        $(".noUi-origin:last-of-type .noUi-handle").append("<i></i>").children().text(data_max_text);
    }
    $("input[type=number]").on("click", function () {
        var val = $(this).val();
        $(this).val("");
        $(this).blur(function() {
            var val_change = $(this).val();
            if (val_change == "") {
                $(this).val(val);
            }
        });
    });

    var refText = $('.part-info-category').find('[data-ref="text"]');
    var categoryInfoSelector = $('.part-info-category');

    if (refText.length) {

        var refTextDiv = refText.children();
        var refTextDivHeight = refText.children().height();
        var refTextDivHtml = refTextDiv.text();

        if(refTextDivHeight < 100) {
            $('[data-click="showMore"]').hide();
        } else {
            $('[data-click="showMore"]').show();
        }

        var maxHeight = 100;
        var minHeight = 90;

        var firstPHeight = 0;
        var useMinHeight = !refText.find("p:first-of-type").length;

        if(!useMinHeight) {
            firstPHeight = refText.find("p:first-of-type").height()
        }

        if(useMinHeight || firstPHeight > 100) {
            refText.css('height','4.9em');
        } else {
            refText.height(refText.find("p:first-of-type").height());
        }

        $(window).off("resize.headText");
        $(window).on("resize.headText", function(){
            refText.height(refText.find("p:first-of-type").height());
        });

        categoryInfoSelector.on("click", '[data-click="showMore"]', function() {
            var elm = $(this);
            var text = elm.find("[data-text]");

            refText.addClass("transition");

            if (!elm.hasClass("state--active")) {
                elm.addClass("state--active");
                text.text(text.data("text")[1]);
                refText.height(refText.children().height())
            } else {
                elm.removeClass("state--active");
                text.text(text.data("text")[0]);

                if(useMinHeight || firstPHeight > 100) {
                    refText.css('height','4.9em');
                } else {
                    refText.height(refText.find("p:first-of-type").height());
                }
            }
        });
    }

}
